import spacings from 'shared-tokens/utils/tokens/spacings';
import colors from 'shared-tokens/utils/tokens/colors';
import createBreakpoint from 'shared-tokens/utils/breakpoints';

const brpM = createBreakpoint('m');

export const mainCls = 'csa_mymenu';
export default {
  [mainCls]: {
    position: 'fixed',
    top: 60,
    right: 0,
    width: 260,
    height: 'calc(100vh - 60px)',
    background: colors.w.rgba,
    borderTop: `3px solid ${colors.primary.rgba}`,
    boxShadow: '0 2px 7px 0 rgba(0,0,0,.13)',
    zIndex: 11,
    transform: 'translate(100%, 0)',
    '& ul': {
      listStyleType: 'none',
    },
    '&::before': {
      content: '""',
      position: 'absolute',
      top: -8,
      right: spacings.m,
      width: 0,
      height: 0,
      background: '#fff',
      borderColor: `${colors.primary.rgba} ${colors.primary.rgba} transparent transparent`,
      borderStyle: 'solid',
      borderWidth: 8,        
      transform: 'rotate(-45deg)',
    },
    [brpM]: {
      height: 'auto',
    },
  },
  [`${mainCls}--opn`]: {
    zIndex: 103,
    transform: 'translate(0, 0)',
    [brpM]: {
      right: spacings.m,
    },
  },
  [`${mainCls}__head`]: {
    display: 'flex',
    lineHeight: '42px',
  },
  [`${mainCls}__head--btn`]: {
    marginLeft: 'auto',
    background: 'transparent',
    border: '0 none',
    cursor: 'pointer',
    '&:hover': {
      color: `${colors.primary.rgba}!important`,
    },
  },
  [`${mainCls}__body`]: {
    maxHeight: 'calc(100vh - 102px)',
    overflowY: 'scroll',
    [brpM]: {
      maxHeight: 'none',
    },
  },
  [`${mainCls}__usr`]: {
    position: 'relative',
    paddingBottom: 4,
    lineHeight: '20px',
    background: '#f0f2f5',
  },
  [`${mainCls}__usr--name`]: {
    paddingTop: 6,
    paddingBottom: 2,
  },
  [`${mainCls}__usr--gear`]: {
    position: 'absolute',
    right: spacings.m,
    bottom: spacings.s,
    width: 20,
    height: 20,
    color: colors.f2.rgba,
    '&:hover': {
      color: `${colors.secondary.rgba}!important`,
    },
  },
  [`${mainCls}__linkLst`]: {
    '&:last-of-type': {
      marginBottom: 132,
      border: '0 none',
      [brpM]: {
        marginBottom: spacings.m,
      },
    },
  },
  [`${mainCls}__linkLst--dt`]: {
    fontSize: 12,
  },
  [`${mainCls}__linkLst--dt--new`]: {
    '&::after': {
      content: '"Novità"',
      display: 'inline-block',
      marginLeft: 5,
      padding: '0 7px',
      height: 14,
      fontSize: 9,
      lineHeight: '14px',
      color: colors.w.rgba,
      background: '#ff9a2b',
      borderRadius: 3,
      verticalAlign: 'text-top',
    }
  },
  [`${mainCls}__linkLst--a`]: {
    display: 'block',
    lineHeight: '34px',
    '&:hover': {
      color: `${colors.primary.rgba}!important`,
    },
  },
  [`${mainCls}__ovrl`]: {
    position: 'fixed',
    top: 0,
    left: 0,
    background: '#000',
    opacity: 0,
    transition: 'opacity .3s linear',
    zIndex: 102,
  },
  [`${mainCls}__ovrl--opn`]: {
    right: 0,
    bottom: 0,
    opacity: '.3',
  },
};